import React from 'react';
import './RecentEpisode.css';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { Helmet } from 'react-helmet-async';
import { Episode } from '../types/types';

interface RecentEpisodeProps {
  episode: Episode;
}

const RecentEpisode: React.FC<RecentEpisodeProps> = ({ episode }) => {
  useScrollAnimation([]);

  // Schema.org structured data for video content
  const videoSchema = {
    "@context": "https://schema.org",
    "@type": "VideoObject",
    "name": episode.title,
    "description": episode.description || "",
    "thumbnailUrl": `https://i.ytimg.com/vi/${episode.thumbnailId}/maxresdefault.jpg`,
    "uploadDate": episode.date,
    "duration": `PT${episode.duration.replace(/:/g, "H")}S`,
    "embedUrl": `https://www.youtube.com/embed/${episode.videoId}`,
    "publisher": {
      "@type": "Organization",
      "name": "Basketball Culture Podcast",
      "logo": {
        "@type": "ImageObject",
        "url": "YOUR_LOGO_URL"
      }
    }
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(videoSchema)}
        </script>
        <meta name="description" content={`Watch the latest episode of Basketball Culture Podcast: ${episode.title}`} />
        <meta name="keywords" content="basketball podcast, basketball culture, sports podcast" />
      </Helmet>

      <section className="recent-episode" aria-label="Latest Episode Section">
        <div className="episode-container">
          <h2 className="section-title scroll-animate">LATEST EPISODE</h2>
          <article className="episode-card scroll-animate">
            <div className="video-container scroll-animate">
              <iframe
                className="video-player"
                src={`https://www.youtube.com/embed/${episode.videoId}`}
                title={episode.title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                loading="lazy"
                aria-label={`${episode.number} video player`}
              />
            </div>
            <div className="episode-info scroll-animate">
              <span className="episode-number" aria-label="Episode number">{episode.number}</span>
              <h3 className="episode-title">
                {episode.title}
              </h3>
              <p className="episode-description scroll-animate">
                {episode.description}
              </p>
              <div className="episode-meta scroll-animate" aria-label="Episode details">
                <time className="episode-date" dateTime={episode.date}>
                  {new Date(episode.date).toLocaleDateString('en-US', { 
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  })}
                </time>
                <span className="episode-duration" aria-label="Episode duration">{episode.duration}</span>
              </div>
            </div>
          </article>
        </div>
      </section>
    </>
  );
};

export default RecentEpisode;
